export const trimPath = (path?: string): string => {
  if (!path) return "";

  if (path.startsWith("refs/heads/origin/")) {
    const trimmedPath = path.replace("refs/heads/origin/", "");
    return trimmedPath;
  } else if (path.startsWith("refs/heads/")) {
    const trimmedPath = path.replace("refs/heads/", "");
    return trimmedPath;
  }
  return path;
};
